import * as React from "react";
import {
    OnlineRentersClaimRequest,
    Image,
    ValuableItemWithStartDate,
    IClaimProperties,
    SOMETHING_ELSE,
    SOMETHING_WAS_DAMAGED,
    SOMETHING_WAS_LOST,
    SOMETHING_WAS_STOLEN
} from "@falcon/services";
import ValuableItemClaimPanel from "./ValuableItemClaimPanel";
import * as moment from "moment";
import {InfoModal} from "../../../../../components/modals/InfoModal";

interface IProps {
    valuableItems: ValuableItemWithStartDate[];
    onOpenModal: (state: boolean) => void;
    onlineRentersClaimRequest: OnlineRentersClaimRequest;
    onItemAdding: (item: IClaimProperties) => void;
    onItemDeleting: (itemId: string) => void;
    onItemUpdate: (item: IClaimProperties) => void;
    onImagesAdding: (itemId: string, images: Image[]) => void;
    onImageRemoving: (itemId: string, imageId: string) => void;
    onValuableItemRemoving: (itemId: string) => void;
}

export class ItemsForClaimPanel extends React.Component<IProps, {}> {

    constructor(props: IProps) {
        super(props);
    };

    public render() {
        return (
            <React.Fragment>
                <h1 className="page-heading-black">{this.renderHeadingWording()}</h1>
                <div className="section-panel">
                    {this.props.valuableItems && this.props.valuableItems.length > 0 &&
                    <div className="section pb-0">
                        <div className="section-contents">
                            <div className="detail">
                                <label>{this.renderWording()}</label>
                                <div className="falcon-checkbox form-group mt-3 mb-3">
                                    {this.renderItemsForClaim()}
                                </div>
                            </div>

                        </div>
                    </div>}
                    <div className="section">
                        <div className="section-contents">
                            <div className="detail">
                                {this.props.valuableItems && this.props.valuableItems.length > 0 &&
                                <div className="detail-key font-weight-semi-bold">
                                    {this.props.onlineRentersClaimRequest.claimingReason !== "Something else" ? "None of the above items? Please add them below" : "Please add items you wish to claim for"}
                                </div>}
                                {this.props.valuableItems && this.props.valuableItems.length === 0 &&
                                <div className="detail-key font-weight-semi-bold">
                                    Please add items you wish to claim for
                                </div>}
                                <div className="section-links">
                                    <button id="addNewClaimItem" type="button" className="btn btn-white-dashboard m-auto"
                                            onClick={() => this.props.onOpenModal(true)} disabled={!this.showAddNewItemButton()}>
                                        Add item
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    private showAddNewItemButton = (): boolean => {
        if (!this.props.onlineRentersClaimRequest.itemsForClaim) {
            return true;
        } else if (this.props.onlineRentersClaimRequest.itemsForClaim && this.props.onlineRentersClaimRequest.itemsForClaim.length < 10) {
            return true;
        }

        return false;
    };

    private renderItemsForClaim = (): JSX.Element => {
        const today = moment().format("YYYY-MM-DD");
        const incidentDate = this.props.onlineRentersClaimRequest.accidentDate;
        const minDate: string = moment(incidentDate).isBefore(today) ? incidentDate : today;

        return (
            <React.Fragment>
                {this.props.valuableItems.map((valuableItem: ValuableItemWithStartDate, key: number) =>
                    <div key={valuableItem.valuableItemId}>
                        <div className="d-flex">
                            <div className="form-check mr-3">
                                <input className="custom-control-input"
                                       type="checkbox"
                                       onChange={(e: any) => this.handleCheckboxChange(e, valuableItem)}
                                       name={valuableItem.valuableItemId}
                                       id={`valuableItem-checkbox-${key}`}
                                       checked={this.isChecked(valuableItem.valuableItemId)}
                                       disabled={this.isDisabled(valuableItem, minDate)}/>
                                <label className="custom-control-label" htmlFor={`valuableItem-checkbox-${key}`}>
                                    <div id={valuableItem.valuableItemId} className="checkbox-big"/>
                                </label>
                            </div>
                            <div className="d-flex">{valuableItem.description}, {valuableItem.valuableItemType.code}
                        </div>
                        {valuableItem.premium && valuableItem.premium > 0 && this.disabledValuableItemInfoButton(valuableItem, today, incidentDate)}</div>
                        {this.isChecked(valuableItem.valuableItemId)
                        && <ValuableItemClaimPanel
                            item={valuableItem}
                            onItemUpdate={this.props.onItemUpdate}
                            onImagesAdding={this.props.onImagesAdding}
                            onImageRemoving={this.props.onImageRemoving}
                            onValuableItemRemoving={this.props.onValuableItemRemoving}
                            onlineRentersClaimRequest={this.props.onlineRentersClaimRequest}/>}
                    </div>
                )}
            </React.Fragment>
        )
    };

    private handleCheckboxChange = (event: any, valuableItem: ValuableItemWithStartDate): void => {
        const checked: boolean = this.isChecked(valuableItem.valuableItemId);
        if (checked) {
            this.props.onItemDeleting(valuableItem.valuableItemId);
        } else {
            const newItem: any = {
                type: valuableItem.valuableItemType.code,
                description: valuableItem.description,
                price: valuableItem.value,
                claimType: this.props.onlineRentersClaimRequest.claimingReason,
                images: [],
                itemId: valuableItem.valuableItemId,
                startDate: valuableItem.startDate!,
                specifiedItemId: valuableItem.id
            };
            this.props.onItemAdding(newItem);
        }
    };

    private isChecked = (itemId: string): boolean => {
        const items: any[] = this.props.onlineRentersClaimRequest.itemsForClaim ? this.props.onlineRentersClaimRequest.itemsForClaim : [];
        return items.map(item => item.itemId).includes(itemId);
    };

    private isDisabled = (valuableItem: ValuableItemWithStartDate, minDate: string): boolean => {
        const valuableItemStartDate: string = moment(valuableItem.startDate).format("YYYY-MM-DD");
        return moment(valuableItemStartDate).isAfter(minDate);
    };

    private disabledValuableItemInfoButton = (valuableItem: ValuableItemWithStartDate, today: string, incidentDate: string): JSX.Element => {
        let wording: string;
        const valuableItemStartDate: string = moment(valuableItem.startDate).format("YYYY-MM-DD");
        const valuableItemStartDateFormatted: string = moment(valuableItem.startDate).format("DD/MM/YYYY");
        if (moment(today).isSame(incidentDate) && moment(valuableItemStartDate).isAfter(today)) {
            wording = `will start on ${valuableItemStartDateFormatted}`;
        } else if (moment(incidentDate).isBefore(today) && moment(valuableItemStartDate).isAfter(incidentDate)) {
            wording = `started on ${valuableItemStartDateFormatted}`;
        } else {
            wording = "";
        }

        return (
            <React.Fragment>
                {wording !== "" &&
                <InfoModal title="Specified item description" className={"ml-3"}>
                    Your cover for this item <b>{wording}</b> so unfortunately, {' '}
                    we are unable to process a claim prior to your covert start date, as you are not yet covered.
                </InfoModal>}
            </React.Fragment>
        )
    };

    private renderWording = (): string => {
        switch (this.props.onlineRentersClaimRequest.claimingReason) {
            case SOMETHING_WAS_DAMAGED:
                return "Please select or add item(s) that have been damaged";
            case SOMETHING_WAS_STOLEN:
                return "Please select or add item(s) that have been stolen";
            case SOMETHING_WAS_LOST:
                return "Please select or add item(s) that have been lost";
            case SOMETHING_ELSE:
                return "Please select or add item(s) that you wish to claim for";
            default:
                return "";
        }
    };

    private renderHeadingWording = (): string => {
        switch (this.props.onlineRentersClaimRequest.claimingReason) {
            case SOMETHING_WAS_DAMAGED:
                return "What items have been damaged?";
            case SOMETHING_WAS_STOLEN:
                return "What items have been stolen?";
            case SOMETHING_WAS_LOST:
                return "What items have been lost?";
            case SOMETHING_ELSE:
                return "What items you wish to claim for?";
            default:
                return "";
        }
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/renters/rentersClaims/ItemsForClaimPanel.tsx